import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import accountReceivableBadDebtHistoriesFilterList from "../../components/accountReceivableBadDebtHistories/filter/accountReceivableBadDebtHistoriesFilterList";
import AccountReceivableBadDebtHistoryExpandList from "../../components/accountReceivableBadDebtHistories/expand/AccountReceivableBadDebtHistoryExpandList";
import AccountReceivableBadDebtHistoryFooterList from "../../components/accountReceivableBadDebtHistories/footer/AccountReceivableBadDebtHistoryFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountReceivableDabDebtHistoriesList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.label.bad_debt_history"
        empty={false}
        actions={<DownloadAction />}
        filters={accountReceivableBadDebtHistoriesFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        queryOptions={{
          meta: { sort: ["customer_bad_debts.customer_id ASC"] },
        }} // overide default sort
      >
        <DatagridConfigurable
          body={
            <MyDatagridBody
              footer={<AccountReceivableBadDebtHistoryFooterList />}
            />
          }
          bulkActionButtons={false}
          expand={<AccountReceivableBadDebtHistoryExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company.alias" />
          ) : null}
          <TextField source="code" label="mine.label.code" />
          <TextField source="name" label="mine.label.name" />
          <NumberField source="total_debt" label="mine.label.debt" />
          <NumberField
            source="total_installment"
            label="mine.label.installment"
          />
          <NumberField
            source="total_correction"
            label="mine.label.correction"
          />
          <NumberField source="total_remain" label="mine.label.remain" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default AccountReceivableDabDebtHistoriesList;
